import React, { useEffect } from "react";
import SessionLoader from "../components/SessionLoader";
import IntraIdCleaning from "../components/IntraIdCleaning";
import SessionSummary from "../components/SessionSummary";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { currentSessionAtom, currentSessionModeAtom } from "../state";
import { useParams } from "react-router-dom";
import InterIdCleaning from "../components/InterIdCleaning";
import { Box } from "@mui/material";
import Spinner from "../components/Spinner";

const renderSession = (sessionId, currentSessionMode) => {
  switch (currentSessionMode) {
    case "intra":
      return (
        <React.Suspense
          fallback={<Spinner message={"Preparing the awesomeness ..."} />}
        >
          <IntraIdCleaning sessionId={sessionId} />
        </React.Suspense>
      );
    case "inter":
      return (
        <React.Suspense
          fallback={<Spinner message={"Preparing the awesomeness ..."} />}
        >
          <InterIdCleaning sessionId={sessionId} />
        </React.Suspense>
      );
    case "summary":
      return <SessionSummary />;
    default:
      throw new Error(`Invalid Session Mode: ${currentSessionMode}`);
  }
};

const HomePage = () => {
  const { sessionId } = useParams();

  const setCurrentSession = useSetRecoilState(currentSessionAtom);
  useEffect(
    () => setCurrentSession({ id: sessionId }),
    [sessionId, setCurrentSession]
  );

  let currentSessionMode = useRecoilValue(currentSessionModeAtom);

  return (
    <SessionLoader>
      <React.Suspense>
        <Box sx={{ flexGrow: 1 }}>
          {renderSession(sessionId, currentSessionMode)}
        </Box>
      </React.Suspense>
    </SessionLoader>
  );
};

export default HomePage;
